3<template>
  <div id="detail">
    <h1>{{ $t("Detail.title") }}</h1>
    <!-- エラーメッセージ -->
    <table class="msgT" v-if="resultError > 0">
    <tr>
      <td class="msg"><p v-html="getMsg"></p></td>
    </tr>
    </table>
    <!-- ボタン群 -->
    <table class="buttonGrp">
    <tr>
      <!-- 結果に戻る -->
      <td class="tdBack"><button v-on:click="doReturnList" class="back" :disabled="searching">{{ $t("Detail.Button.back") }}</button></td>
      <!-- 前へ/次へ -->
      <td class="tdPrevNext"><button v-if="getEnablePrev" v-on:click="doPrev" class="PrevNext" :disabled="searching">{{ $t("Detail.Button.previous") }}</button></td>
      <td class="tdPrevNext"><button v-if="getEnableLast" v-on:click="doNext" class="PrevNext" :disabled="searching">{{ $t("Detail.Button.next") }}</button></td>
      <!-- 報告 -->
      <td class="tdRequest">
        <table class="tableRequest">
        <tr><!-- 報告しない -->
          <td><button v-on:click="doPendingRequest" class="pending" v-bind:style="styleUserPending" :disabled="getEnablePending">{{ $t("Detail.Button.pending") }}</button></td>
        </tr>
        <tr><!-- 報告する -->
          <td><button v-on:click="doSubmitRequest" class="submit" v-bind:style="styleUserSubmit" :disabled="getEnableRequest">{{ $t("Detail.Button.submit") }}</button></td>
        </tr>
        </table>
      </td>
    </tr>
    </table>

    <!-- 基本情報 -->
    <table>
    <thead>
      <tr>
        <th colspan=4>{{ $t("Detail.BasicInfo.title") }}</th>
      </tr>
    </thead>
    <tbody>
    <tr><!-- 日時/ステータス -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.dateTime')"></p></th>
      <td class="detail_item_view">{{ params.dateTime }}</td>
      <th class="detail_item2"><p v-html="$t('Detail.BasicInfo.status')"></p></th>
      <td class="detail_item_view2">{{ getStatus(params.status) }} {{ getZendeskNo }}</td>
    </tr>
    <tr><!-- 販売店本部 -->
      <th class="detail_item_return"><p v-html="$t('Detail.BasicInfo.staffNameHQ')"></p></th>
      <td class="detail_item_view"><input type="text" class="required_name" v-model="params.staffNameHQ" id="staffNameHQ" @input="onChangeInput" :placeholder="$t('Common.requiredNameEx')" autocomplete="on"></td>
      <th class="detail_item_return2"><p v-html="$t('Detail.BasicInfo.staffEmailHQ')"></p></th>
      <td class="detail_item_view2"><input type="text" class="required_email" v-model="params.staffEmailHQ" id="staffEmailHQ" @input="onChangeInput" :placeholder="$t('Common.requiredEmailEx')" autocomplete="on"></td>
    </tr>
    <tr><!-- コメント(販売店本部) -->
      <th class="detail_item_return"><p v-html="$t('Detail.BasicInfo.commentHQ')"></p></th>
      <td colspan="3"><textarea id="commentHQ" class="hq_comment" rows="3" cols="67" v-model="params.commentHQ" :placeholder="$t('Detail.BasicInfo.commentHQEx')"></textarea></td>
    </tr>
    <tr><!-- コメント(ディーラー) -->
      <th class="detail_item_return"><p v-html="$t('Detail.BasicInfo.commentDealer')"></p></th>
      <td colspan="3"><textarea id="commentDealer" class="dealer_comment" rows="3" cols="67" disabled=true v-model="params.commentDealer"></textarea></td>
    </tr>
    <tr><!-- 国コード/地域コード -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.nation')"></p></th>
      <td class="detail_item_view">{{ params.dealerCountryCode }}</td>
      <th class="detail_item2"><p v-html="$t('Detail.BasicInfo.areaCode')"></p></th>
      <td class="detail_item_view2">{{ params.areaCode }}</td>
    </tr>
    <tr><!-- ディーラーコード/ディーラ名 -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.dealerCode')"></p></th>
      <td class="detail_item_view">{{ params.dealerCode }}</td>
      <th class="detail_item2"><p v-html="$t('Detail.BasicInfo.dealerName')"></p></th>
      <td class="detail_item_view2">{{ params.dealerName }}</td>
    </tr>
    <tr><!-- 担当者名/電話番号 -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.staffName')"></p></th>
      <td class="detail_item_view">{{ params.staffName }}</td>
      <th class="detail_item2"><p v-html="$t('Detail.BasicInfo.phoneNumber')"></p></th>
      <td class="detail_item_view2">{{ params.phoneNumber }}</td>
    </tr>
    <tr><!-- 車両名/車両型式 -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.vehicleName')"></p></th>
      <td class="detail_item_view">{{ params.vehicleName }}</td>
      <th class="detail_item2"><p v-html="$t('Detail.BasicInfo.model')"></p></th>
      <td class="detail_item_view2">{{ params.model }}</td>
    </tr>
    <tr><!-- GTS+バージョン -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.gtsVersion')"></p></th>
      <td class="detail_item_view">{{ params.gtsVersion }}</td>
    </tr>
    <tr><!-- ソフトウェアID  -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.softwareId')"></p></th>
      <td class="detail_item_view" colspan="3">{{ params.softwareId }}</td>
    </tr>
    <tr><!-- VIM情報 -->
      <th class="detail_item" colspan="4"><p v-html="$t('Detail.BasicInfo.Vin.title')"></p></th>
    </tr>
    <tr><!-- 名称 /DLL  -->
      <th class="detail_item"><p v-html="$t('Detail.BasicInfo.Vin.name')"></p></th>
      <td class="detail_item_view">{{ params.name }}</td>
      <th class="detail_item2"><p v-html="$t('Detail.BasicInfo.Vin.dll')"></p></th>
      <td class="detail_item_view2"><p v-html="params.dll"></p></td>
    </tr>
    </tbody>
    </table>
    <br>

    <!-- スクリーンショット -->
    <table>
      <thead>
        <tr>
          <th colspan="6">{{ $t("Detail.Screenshot.title") }}</th>
        </tr>
      </thead>
    </table>
    <table class="screen">
    <viewer :images="imageSrc" :options="{ 'inline': false, 'navbar': false, 'rotatable': false, 'scalable': false}">
    <tr v-for="(n, key) in imgRow" :key="key">
      <td>
        <img :src="imageSrc[(n*2)-2]" width="300">
      </td>
      <td>
        <img v-if="imgNum >= n*2" :src="imageSrc[(n*2)-1]" width="300">
      </td>
    </tr>
    </viewer>
    </table>
  </div>
</template>

<script>
import CONST from '../const/const.js'  // 定数

export default {
  name: 'Detail',
  data () {
    return {
      // 項目-初期値
      no: -1,
      params: {
        id: '',
        errorId: '',
        dateTime: '',
        status: '',
        staffNameHQ: '',
        staffEmailHQ: '',
        commentHQ: '',
        commentDealer: '',
        areaCode: '',
        dealerCode: '',
        dealerName: '',
        dealerCountryCode: '',
        staffName: '',
        phoneNumber: '',
        vehicleName: '',
        model: '',
        gtsVersion: '',
        softwareId: '',
        name: '',
        dll: '',
        zendeskNo: '',
      },
      imageSrc: [],
      imgNum: 0,
      imgRow: 0,
      searching: true, // true:検索中、false:検索中ではない（多重送信防止）
      // 検索結果一覧
      datalists: [],
      styleUserPending: {
        backgroundColor: '#d3d3d3',
      },
      styleUserSubmit: {
        backgroundColor: '#d3d3d3',
      },
      resultError: CONST.SEARCH.ERROR.NOT_ERROR,   // 0:エラー無、1以上:エラー有
    }
  },

  /*
   * components: 子コンポーネント
   */
  components: {
  },

  /*
   * created: 初期処理
   */
  created : function(){
    // 選択Noパラメータを取得
    this.no = this.$route.params.no;
//console.log(this.$route);
    // 検索結果一覧のリストを取得
    if(Object.prototype.hasOwnProperty.call(sessionStorage, 'search-result-list')) {
      this.datalists = JSON.parse(sessionStorage.getItem('search-result-list'));
console.log(this.datalists);

      // 範囲外のNoの場合（URL手入力）は最小値 or 最大値に設定
      if (isNaN(this.no) || this.no < 1) {
        this.no = 1;
      }
      if (this.no > this.datalists.length) {
        this.no = this.datalists.length;
      }
      // 小数点の場合は切り捨て（整数部有効）
      this.no = Math.floor(this.no);

      // DBから詳細情報取得
      this.getViewData();
    } else {
      this.searching = false;
    }
  },

  /*
   * mounted: elementへのマウント
   */
  mounted : function() {
  },

  /*
   * beforeRouteUpdate: パラメーター変更の検知
   */
  beforeRouteUpdate (to, from, next) {  // eslint-disable-line
    // 認証チェック
    this.$cognito.isAuthenticated().then(session => {// eslint-disable-line
      // 再描画前のアクション
      this.searching = true;
      this.no = to.params.no
console.log('beforeRouteUpdate');
      next();

      // 再描画後のアクション
      this.getViewData();
    })
    // Cognitoの認証エラーの場合
    .catch(error => { // eslint-disable-line
console.log('詳細画面 - 認証エラー');
      this.moveSigninPage();
    })
  },

  /*
   * methods: メソッド
   */
  methods: {
    // 検索画面に戻る
    doReturnList: function() {
      this.$router.push('/search');
    },
    // 前へ
    doPrev: function() {
      this.$router.push({
        path: '/detail',
        name: 'Detail',
        params: {
          no: this.no - 1
        },
      })
    },
    // 次へ
    doNext: function() {
      this.$router.push({
        path: '/detail',
        name: 'Detail',
        params: {
          no: this.no + 1
        },
      })
    },
    // 報告しない
    doPendingRequest: function() {
      // 結果一覧範囲外のNoの場合は処理しない
      if (this.no <1 || this.no > this.datalists.length) {
        return;
      }

      // 認証チェック
      this.$cognito.isAuthenticated().then(session => {
        this.searching = true;
        this.resultError = CONST.SEARCH.ERROR.NOT_ERROR;

        // Json形式の検索条件を取得
        var jsonStr = this.getPostJson(CONST.ACTION_MODE.PENDING);
//console.log(jsonStr);
//console.log(session);
        // IDトークンによるアクセス認可用ヘッダーを生成
        var header = this.getAuthorizationHeader(session);

        // API GatewayへPutして検索を実行する
        this.$axios.put('/', jsonStr, header).then(responsePut => {
console.log(responsePut);
          // 正常終了
          if (responsePut.data.statusCode === 200) {
            // ステータス処理
            this.params.status = responsePut.data.request_status;
            this.datalists[this.no - 1].requestStatus = responsePut.data.request_status;
            sessionStorage.setItem('search-result-list', JSON.stringify(this.datalists));
          } else {
            this.resultError = CONST.SEARCH.ERROR.NETWORK_ERROR;
          }
        })
        // Putエラーの場合
        .catch(error => {
          this.resultError = CONST.SEARCH.ERROR.NETWORK_ERROR;
console.log("putエラー");
          console.log(error);
        })
        .finally(v=>{  // eslint-disable-line
          this.searching = false;
        });
      })
      // Cognitoの認証エラーの場合
      .catch(error => { // eslint-disable-line
console.log('詳細画面 - 認証エラー');
        this.moveSigninPage();
      })
    },
    // 報告する
    doSubmitRequest: function() {
      // 結果一覧範囲外のNoの場合は処理しない
      if (this.no <1 || this.no > this.datalists.length) {
        return;
      }

      // 認証チェック
      this.$cognito.isAuthenticated().then(session => {
        this.searching = true;
        this.resultError = CONST.SEARCH.ERROR.NOT_ERROR;

        // Json形式の検索条件を取得
        var jsonStr = this.getPostJson(CONST.ACTION_MODE.SUBMITTED);
//console.log(jsonStr);
//console.log(session);
        // IDトークンによるアクセス認可用ヘッダーを生成
        var header = this.getAuthorizationHeader(session);

        // API GatewayへPutして検索を実行する
        this.$axios.put('/', jsonStr, header).then(responsePut => {
console.log(responsePut);
          // 正常終了
          if (responsePut.data.statusCode === 200) {
            // ステータス処理
            this.params.status = responsePut.data.request_status;
            this.params.zendeskNo = responsePut.data.ticket;
            this.datalists[this.no - 1].requestStatus = responsePut.data.request_status;
            this.datalists[this.no - 1].zendeskNo = responsePut.data.ticket;
            sessionStorage.setItem('search-result-list', JSON.stringify(this.datalists));
console.log('正常終了');
            // ステータスが報告済みの場合は「報告する/しない」ボタン押下不可
            this.styleUserPending.backgroundColor = '#d3d3d3';
            this.styleUserPending.cursor = 'not-allowed';
            this.styleUserSubmit.backgroundColor = '#d3d3d3';
            this.styleUserSubmit.cursor = 'not-allowed';
          } else {
            // 異常終了
            this.resultError = CONST.SEARCH.ERROR.ZENDESK_ERROR;
          }
        })
        // Putエラーの場合
        .catch(error => {
          this.resultError = CONST.SEARCH.ERROR.NETWORK_ERROR;
console.log("putエラー");
          console.log(error);
        })
        .finally(v=>{  // eslint-disable-line
          this.searching = false;
        });
      })
      // Cognitoの認証エラーの場合
      .catch(error => { // eslint-disable-line
console.log('詳細画面 - 認証エラー');
        this.moveSigninPage();
      })
    },
    // 報告するボタン有効チェック
    onChangeInput() {
      // 必須項目未入力の場合と報告済みの場合は報告不可
      if (this.params.staffNameHQ.length < 1 || this.params.staffEmailHQ.length < 1 ||
          this.params.status === CONST.STATUS.SUBMITTED) {
        this.styleUserSubmit.backgroundColor = '#d3d3d3';
        this.styleUserSubmit.cursor = 'not-allowed';
      } else {
        this.styleUserSubmit.backgroundColor = '#ffbb00';
        this.styleUserSubmit.cursor = 'pointer';
      }
    },
    // データ取得
    getViewData() {
      // 結果一覧範囲外のNoの場合は処理しない
      if (this.no <1 || this.no > this.datalists.length) {
        this.searching = false;
        return;
      }

console.log("getViewData");
      // 認証チェック
      this.$cognito.isAuthenticated().then(session => {// eslint-disable-line
        this.resultError = CONST.SEARCH.ERROR.NOT_ERROR;
        this.params.id = this.datalists[this.no - 1].id;
        this.params.errorId = this.datalists[this.no - 1].errorId;

        // Json形式の検索条件を取得
        var jsonStr = this.getPostJson(CONST.ACTION_MODE.DETAIL);
//console.log(jsonStr);
//console.log(session);
        // IDトークンによるアクセス認可用ヘッダーを生成
        var header = this.getAuthorizationHeader(session);

        // API GatewayへPostして検索を実行する
        this.$axios.post('/', jsonStr, header).then(responsePost => {
//console.log(responsePost);
          var responseData = JSON.parse(responsePost.data);
//console.log(responseData);
          // 正常終了
          if (responseData.statusCode === 200) {
            var items = responseData.Items[0];
//console.log(items);

            // 日付を加工
            var s = items.error_id;
            var d = s.slice(0, 4) + '-' + s.slice(4, 6) + '-' + s.slice(6, 8);
            var t = s.slice(8, 10) + ':' + s.slice(10, 12) + ':' + s.slice(12, 14);
            // UTC日時で設定
            var date_utc = new Date(d + 'T' + t + 'Z');
            // YYYY/MM/DD HH:mmに変換
            var date_format = date_utc.getFullYear() + '/' + ('0' + (date_utc.getMonth() + 1)).slice(-2) + '/' +('0' + date_utc.getDate()).slice(-2) + ' ' +  ('0' + date_utc.getHours()).slice(-2) + ':' + ('0' + date_utc.getMinutes()).slice(-2);

            this.params = {
              id: this.params.id,
              errorId: this.params.errorId,
              dateTime: date_format,
              status: items.request_status,
              staffNameHQ: items.staff_name,
              staffEmailHQ: items.staff_email,
              commentHQ: items.headquarters,
              commentDealer: items.comment,
              dealerCountryCode: items.dealer_country_code,
              areaCode: items.area_code,
              dealerCode: items.dealer_code,
              dealerName: items.dealer_name,
              staffName: items.user_name,
              phoneNumber: items.phone_number,
              vehicleName: items.vehicle_name,
              model: items.model,
              gtsVersion: items.version,
              softwareId: items.guid,
              name: items.vim_name,
              dll: items.vim_dll,
              zendeskNo: items.zendesk_no,
            }
            // 報告する/報告しないボタン
            if (this.params.status === CONST.STATUS.SUBMITTED) {
              // ステータスが報告済みの場合は報告する/報告しないボタン押下不可
              this.styleUserPending.backgroundColor = '#d3d3d3';
              this.styleUserPending.cursor = 'not-allowed';
              this.styleUserSubmit.backgroundColor = '#d3d3d3';
              this.styleUserSubmit.cursor = 'not-allowed';
            } else {
              this.styleUserPending.backgroundColor = '#ffbb00';
              this.styleUserPending.cursor = 'pointer';

              // 必須項目未入力の場合は報告不可
              if (this.params.staffNameHQ.length < 1 || this.params.staffEmailHQ.length < 1) {
                this.styleUserSubmit.backgroundColor = '#d3d3d3';
                this.styleUserSubmit.cursor = 'not-allowed';
              } else {
                this.styleUserSubmit.backgroundColor = '#ffbb00';
                this.styleUserSubmit.cursor = 'pointer';
              }
            }

            // イメージ取得
            this.imageSrc = [];
            this.$axios.get('/', {
              headers: {
                "Authorization": session.idToken.jwtToken
              },
              params: {
                "ErrorId" : s
              }
            })
            .then(responseGet => {
//console.log(responseGet);
              var resImage = JSON.parse(JSON.stringify(responseGet.data));
console.log(resImage);

              if (resImage.statusCode === 200) {
                this.imgNum = resImage[CONST.IMAGE.FILES].length;
                this.imgRow = Math.ceil(this.imgNum / 2) // Image表示行数
                resImage[CONST.IMAGE.FILES].forEach((val, index) => {// eslint-disable-line
//console.log(val[CONST.IMAGE.KEY]);
                  this.imageSrc.push(val[CONST.IMAGE.KEY]);
                });
              }
            })
            // Getエラーの場合
            .catch(error => {
              this.resultError = CONST.SEARCH.ERROR.NETWORK_ERROR;
//console.log("getエラー");
              console.log(error);
            })
            .finally(v=>{  // eslint-disable-line
              this.searching = false;
            });
          }
        })
        // Postエラーの場合
        .catch(error => {
          this.resultError = CONST.SEARCH.ERROR.NETWORK_ERROR;
//console.log("postエラー");
          console.log(error);
        })
        .finally(v=>{  // eslint-disable-line
          this.searching = false;
        });
      })
      // Cognitoの認証エラーの場合
      .catch(error => { // eslint-disable-line
console.log('詳細画面 - 認証エラー');
        this.moveSigninPage();
      })
    },
    // 検索用Json生成
    getPostJson(mode) {
      return {
        mode: mode,
        id: this.params.id,
        errorId: String(this.params.errorId),
        staffEmail: this.params.staffEmailHQ,
        staffName: this.params.staffNameHQ,
        headquarters: this.params.commentHQ,
      };
    },
    // IDトークンによるアクセス認可用ヘッダー取得
    getAuthorizationHeader(session) {
      return {
        headers: {
          "Authorization": session.idToken.jwtToken
        }
      };
    },
    // サインインページ遷移
    moveSigninPage() {
      var home = '';// eslint-disable-line
      if(this.$store.state.user) {
        if(this.$store.state.user['group'] === CONST.USER_KBN.DEVELOP) {
          home = '/signin/0';
        } else {
          home = '/kitora/403';
        }
      }

      this.$store.commit('setUser', null)
      this.$cognito.signout();
      this.$router.push(home);
    },
  },

  /*
   * computed: 算出プロパティ
   */
  computed: {
    // ステータス文字列取得
    getStatus: function() {
      return function(val) {
        switch (val) {
          case CONST.STATUS.NOT_REQUESTED: // 未処理（東京リージョン/北京リージョン）
            return this.$t("Common.statusItem.notRequested");
          case CONST.STATUS.SUBMITTED: // 報告済（東京リージョン/北京リージョン）
            return this.$t("Common.statusItem.submitted");
          case CONST.STATUS.PENDING: // 報告せず（東京リージョン）
            return this.$t("Common.statusItem.pending");
          default:
            return '';
        }
      }
    },
    // 前へボタン表示/非表示
    getEnablePrev: function() {
      if (this.no === 1) {
        return false;
      } else {
        return true;
      }
    },
    // 次へボタン表示/非表示
    getEnableLast: function() {
      if (this.no === this.datalists.length) {
        return false;
      } else {
        return true;
      }
    },
    // 報告しないボタン使用可能/不能
    getEnablePending: function() {
      // ステータスが報告済みの場合は押下不可
      if (this.searching || this.params.status === CONST.STATUS.SUBMITTED) {
        return true;
      } else {
        return false;
      }
    },
    // 報告するボタン使用可能/不能
    getEnableRequest: function() {
      // 担当者氏名/担当者メールアドレス必須入力チェック
      if (this.params.staffNameHQ.length < 1 || this.params.staffEmailHQ.length < 1 ||
          this.searching || this.params.status === CONST.STATUS.SUBMITTED) {
        return true;
      } else {
        return false;
      }
    },
    // zendeskチケットNo取得
    getZendeskNo: function() {
      if (this.params.zendeskNo !== '' && this.params.zendeskNo !== '0') {
        return '(' + this.params.zendeskNo + ')';
      } else {
        return '';
      }
    },
    // 検索結果メッセージ
    getMsg: function() {
      // Postエラー
      if (this.resultError === CONST.SEARCH.ERROR.NETWORK_ERROR) {
        return this.$t("Message.MSG009");
      }

      // Zendesk連携エラー
      if (this.resultError === CONST.SEARCH.ERROR.ZENDESK_ERROR) {
        return this.$t("Message.MSG010");
      }

      // エラーなし
      return "";
    },
  },
}
</script>

<style lang="scss">
/*--------------------
   BASIC CLASSES
--------------------*/
#detail {
  max-width: 640px;
  border: 0px solid #000000;
  margin: 0 auto;
}

/*--------------------
   FORM STYLING
--------------------*/
.buttonGrp {
  width: 100%;
  border: 0px solid #000000;
  border-collapse: collapse;
}
.tdBack {
  text-align: left;
  width: 220px;
}
.tdPrevNext {
  text-align: center;
  width: 100px;
}
.tableRequest {
  width: 220px;
  height: 60px;
  border: 0px solid #000000;
  border-collapse: collapse;
}
.tdRequest {
  line-height: 30px;
  text-align: right;
}

.msgT {
  border: none;
}

.msg {
  text-align: left;
  line-height: 22px;
  color: #ff0000;
  boder: none;
}

/* BUTTON */
.back {
  background-color: #0099e4;
  width: 160px;
}
.PrevNext {
  background-color: #d3d3d3;
  width: 90px;
}
.pending {
  background-color: #d3d3d3;
  width: 180px;
}
.submit {
  background-color: #ffbb00;
  width: 180px;
}
.download {
  background-color: #d3d3d3;
  font-size: 16px;
  width: 200px;
}

/* BASIC INFO */
tbody th.detail_item {
  width: 140px;
  color: #00bfff;
  line-height: 30px;
}
tbody th.detail_item_return {
  width: 140px;
  line-height: 20px;
  color: #00bfff;
}
tbody td.detail_item_view {
  width: 160px;
}

tbody th.detail_item2 {
  width: 160px;
  color: #00bfff;
  line-height: 30px;
}
tbody th.detail_item_return2 {
  width: 150px;
  line-height: 20px;
  color: #00bfff;
}
tbody td.detail_item_view2 {
  width: 180px;
}

.hq_comment {
  background-color: #ffffff;
}
  .hq_comment::placeholder {
    color: #bbb;
    font-style: italic;
  }

.dealer_comment {
  background-color: #d3d3d3;
}

input.required_name {
  width: 150px;
  height: 25px;
  background-color: #ffbb00;
}
  .required_name::placeholder {
    color: #ffffff;
    font-style: italic;
    text-align: center;
    font-size: 11px;
  }
  // オートコンプリート対策
  .required_name:-webkit-autofill {
    box-shadow: 0 0 0 1000px #ffbb00 inset;
  }
input.required_email {
  width: 175px;
  height: 25px;
  background-color: #ffbb00;
}
  .required_email::placeholder {
    color: #ffffff;
    font-style: italic;
    text-align: center;
    font-size: 11px;
  }
  // オートコンプリート対策
  .required_email:-webkit-autofill {
    box-shadow: 0 0 0 1000px #ffbb00 inset;
  }

/* SCREEN SHOT */
.screen td {
//  background-color: #ffffff;
  width: 50%;
  border: 0px solid #a9a9a9;
//  color: #000000;
  padding: 5px 9px;
  text-align: left;
//  font-size: 13px;
}
</style>
